import * as React from 'react';

// Utils
import { withUserWebView } from '@shopee-user/with-web-view';

// Types
import { NavbarHelpButtonProps } from '@shopee-user/business-customization-types';
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

/**
 * Base help button to navigate to help url
 */
const BaseButton = ({
  text,
  helpLink,
  helpLinkClassName,
  webViewNavigateToUrl,
}: NavbarHelpButtonProps & WithUserWebViewProps) => {
  if (!text) {
    return null;
  } else {
    return (
      <span
        onClick={() => {
          webViewNavigateToUrl(helpLink);
        }}
        className={helpLinkClassName}
      >
        {text}
      </span>
    );
  }
};

export const CommonNavbarHelpButton = withUserWebView({})(BaseButton);
